<template>
  <div>
    <el-form
      ref="form"
      class="step3-form"
      :model="form"
      label-width="14%"
      v-if="showForm">
      <template v-if="propsUI.length">
        <div class="title ft-12">商品属性</div>
          <UseCategoryTemplate class="useCategory-wrap" :categoryIds="form.categoryIds" :baseItemId="baseItemId" :shopId="shopId" :getPropValues="getPropValues" platform="tm" :detailHasCategory="detailHasCategory" @clickFill="clickTemPlateFill">
            <div class="props-items">
              <template v-for="(ui, uiIndex) in propsUI">
                <span :key="ui.name">
                  <div v-if="uiIndex === 0" style="margin: 10px 20px;">重要属性</div>
                  <div v-if="ui.firstNoRequired" style="margin: 10px 20px;"><el-divider></el-divider>其他属性</div>
                  <el-form-item
                    v-if="ui.isShowFn ? ui.isShowFn(form) : true"
                    :label="ui.label"
                    :prop="ui.name"
                    :rules="ui.rules"
                    label-width="130px">
                    <template slot="label">
                      <span>{{ui.label}} <el-tag v-if="ui.tipRule && ui.tipRule.length && ui.tipRule.includes('该属性为重要属性')" type="warning" size="mini" effect="dark">重要</el-tag> </span>
                    </template>
                    <component
                      :ref="ui.name"
                      :ui="ui"
                      :is="ui.component.component"
                      :props="ui.component.props"
                      :value="form[ui.name]"
                      @change="(v) => form[ui.name] = v"
                      :form="form"
                      ></component>
                  </el-form-item>
                </span>
              </template>
            </div>
          </UseCategoryTemplate>
       
      </template>
      <template v-if="specificationsUI.length">
        <div class="title ft-12">属性库存信息</div>
        <div class="specifications-items">
          <template v-for="(ui) in specificationsUI">
            <el-form-item
              :key="ui.name"
              v-if="ui.isShowFn ? ui.isShowFn(form) : true"
              :label="formatLabel(ui)"
              :class="[noLabelStyles.includes(ui.name) ? 'noLabel' : '']"
              :prop="ui.name"
              :rules="ui.rules">
              <component
                :ref="ui.name"
                :ui="ui"
                :is="ui.component.component"
                :props="ui.component.props"
                :value="form[ui.name]"
                @change="(v) => form[ui.name] = v"
                :form="form"
                ></component>
            </el-form-item>
          </template>
        </div>
      </template>
      <template v-if="logisticsUI.length">
        <div class="title ft-12">物流信息</div>
        <div class="logistics-items">
          <template v-for="(ui) in logisticsUI">
            <el-form-item
              v-if="ui.isShowFn ? ui.isShowFn(form) : true"
              :key="ui.name"
              :label="ui.label"
              :prop="ui.name"
              :rules="ui.rules">
              <component
                :ref="ui.name"
                :ui="ui"
                :is="ui.component.component"
                :props="ui.component.props"
                :value="form[ui.name]"
                @change="(v) => form[ui.name] = v"
                :form="form"
                :shops="shops"
                ></component>
            </el-form-item>
          </template>
        </div>
      </template>
      <template v-if="descriptionUI.length">
        <div class="title ft-12">商品描述</div>
        <div class="description-items">
          <template v-for="(ui) in descriptionUI">
            <el-form-item
              v-if="ui.isShowFn ? ui.isShowFn(form) : true"
              :key="ui.name"
              :label="ui.label"
              :prop="ui.name"
              :rules="ui.rules">
              <component
                :ref="ui.name"
                :ui="ui"
                :is="ui.component.component"
                :props="ui.component.props"
                :value="form[ui.name]"
                @change="(v) => $set(form, ui.name, v)"
                :form="form"
                ></component>
            </el-form-item>
          </template>
        </div>
      </template>
      <template v-if="othersUI.length">
        <div class="title ft-12">售后及其他</div>
        <div class="others-items">
          <template v-for="(ui) in othersUI">
            <el-form-item
              v-if="ui.isShowFn ? ui.isShowFn(form) : true"
              :key="ui.name"
              :label="ui.label"
              :prop="ui.name"
              :rules="ui.rules">
              <component
                :ref="ui.name"
                :ui="ui"
                :is="ui.component.component"
                :props="ui.component.props"
                :value="form[ui.name]"
                @change="(v) => form[ui.name] = v"
                :form="form"
                ></component>
            </el-form-item>
          </template>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import UseCategoryTemplate from '../../../../UseCategoryTemplate.vue'

import {step3FormUI} from '../utils/ui'
import { step3Form2Data } from "../utils/data";

import _ from 'lodash';

export default {
  props: ['rowData', 'oriDatas', 'schema', 'shops', 'changeToBase', 'baseItemId', 'shopId', 'detailHasCategory'],
  provide() {
    return {
      TmStep3: this
    }
  },
  components: { UseCategoryTemplate },
  data() {
    return {
      form: {},
      propsUI: [],
      specificationsUI: [],
      logisticsUI: [],
      descriptionUI: [],
      othersUI: [],
      showForm: false,
      noLabelNames: ['sku'],
      noLabelStyles: ['sku']
    }
  },
  computed: {
    fieldDescriptorList() {
      return this.oriDatas?.[0]?.fieldDescriptorList;
    },
  },
  watch: {
    schema(v) {
      v && this.init()
    },
    fieldDescriptorList: {
      handler(newVal, oldVal) {
        // oriDatas 变化时，重新初始化表单（如产品参数图片更新）
        if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.init();
        }
      },
      deep: true,
    },
    form: {
      handler(newForm, oldForm) {
        if(newForm['unit'] !== oldForm['unit'] || newForm['food_security.organic_food'] !== oldForm['food_security.organic_food'] || newForm['food_security.is_green_food'] !== oldForm['food_security.is_green_food']) {
          this.handleUI();
        }
      },
      deep: true,
    }
  },
  methods: {
    init() {
      this.showForm = false
      const [ui, form] = step3FormUI.call(this, this.schema, this.oriDatas)
      this.propsUI = ui.props;
      this.specificationsUI = ui.specifications;
      this.logisticsUI = ui.logistics;
      this.descriptionUI = ui.description;
      this.form = form
      this.$set(this.form, 'pureType', this.oriDatas[0].pureType);
      this.handleUI(ui.others);
      this.showForm = true
      this.$nextTick(() => {
        this.$refs.form?.validate()
      })
    },
    handleUI(othersUI) {
        // “计量单位”选择为：
        // 1：每100毫升（value：hundredMilliliter）或每100克（value：hundredGram）时，children中的每份含量（name：partAmount）和营养成分表-计量单位（name：partUnit）置灰，不可填；
        // 2：每份（value：part）时，children中的每份含量（name：partAmount）和营养成分表-计量单位（name：partUnit）为必填
        othersUI = othersUI || _.cloneDeep(this.othersUI)
        const foodNutrition = othersUI.find(ui => ui.name === 'food_security.food_nutrition_table')
        if(foodNutrition) {
          const unit = this.form.unit;
          const childrenList = foodNutrition.component.props.dataSource.children || [];
          if(unit === 'hundredMilliliter' || unit === 'hundredGram') {
            childrenList.forEach(item => {
              if(item.name === 'partAmount' || item.name === 'partUnit') {
                item.component.props.disabled = true;
                item.rules = [];
              } 
            })
            this.form.partAmount = '';
            this.form.partUnit = '';
          } else if(unit === 'part') {
            childrenList.forEach(item => {
              if(item.name === 'partAmount' || item.name === 'partUnit') {
                item.component.props.disabled = false;
                item.rules = [{required: true, message: "必填"}];
              } 
            })
          } else {
            childrenList.forEach(item => {
              if(item.name === 'partAmount' || item.name === 'partUnit') {
                item.component.props.disabled = false;
                item.rules = [];
              } 
            })
          }
        }
        //  选择有机食品为是时，有机证书编号为必填
        const foodOrganicCertification = othersUI.find(ui => ui.name === 'food_security.organic_certification')
        if(foodOrganicCertification) {
          const organic_food = this.form['food_security.organic_food'];
          foodOrganicCertification.rules = organic_food == 1 ? [{required: true, message: "必填"}] : [];
        }

        // 选择绿色食品为是时，绿色食品等级为必填， 绿色产品编号为必填
        const green_food = this.form['food_security.is_green_food'];
        const greenFoodLevel = othersUI.find(ui => ui.name === 'food_security.green_food_level')
        const greenFoodProduceNumber = othersUI.find(ui => ui.name === 'food_security.green_food_produce_number')
        if(greenFoodLevel) {
          greenFoodLevel.rules = green_food == 1 ? [{required: true, message: "必填"}] : [];
        }
        if(greenFoodProduceNumber) {
          greenFoodProduceNumber.rules = green_food == 1 ? [{required: true, message: "必填"}] : [];
        }
        this.othersUI = othersUI;
    },
    formatLabel(ui) {
      return this.noLabelNames.includes(ui.name) ? '' : ui.label
    },
    method_getPropData() {
      return step3Form2Data(this.form, [...this.propsUI],this.oriDatas)  
    },
    method_getData() {
      return new Promise((resolve, reject) => {
        if (!this.$refs.form) {
          this.$message.error('商品类目天猫已废弃，本类目不能发布上商品，请重新选择类目')
          resolve(false)
          return false
        }
        // 拿取规格信息
        let specifications = null
        let skuList = null
        if(!this.form.pureType) {
          if (this.$refs.sku) {
            const skuData = this.$refs.sku[0].method_getData()
            if (!skuData) {
              resolve(false)
              return false
            }
            specifications = skuData[0]
            skuList = skuData[1]
          }
        }

        this.$refs.form.validate((pass) => {
          if (pass) {
            const fieldDescriptorList = step3Form2Data(this.form, [
              ...this.propsUI, ...this.specificationsUI,
              ...this.logisticsUI, ...this.descriptionUI, ...this.othersUI
            ],this.oriDatas)
            // 校验模特试穿信息
            if (this.$refs.size_model_try) {
              let smtData = this.$refs.size_model_try?.[0]?.method_getData();
              if (!smtData) {
                resolve(false);
                return;
              }
              fieldDescriptorList.push(smtData);
            }
            // 处理postage_id
            const postage_id_map = this.shops.reduce((map, curr) => {
              map[curr.shopId] = {
                name: 'postage_id',
                defaultValue: this.form.postage_id[curr.shopId]
              }
              return map
            }, {})
            resolve({
              fieldDescriptorList,
              specifications,
              skuList,
              postage_id_map,
              pureType: this.form.pureType,
            })
          } else {
            resolve(false)
            this.$message.error('请完善表单')
          }
        })
      })
    },
    clickTemPlateFill(row) {
      const parsePlatformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : [];
      const data = [{
        fieldDescriptorList: parsePlatformCatProp
      }]
      const [ui, form] = step3FormUI.call(this, this.schema, data)
      this.setForm(ui, form, 'props')
      this.setForm(ui, form, 'material_prop_149422948')
    },
    setForm(ui, form, field){
      if(field === 'props') {
        const propsUI = ui.props;
        propsUI.map(ui => {
          if(form[ui.name]) {
            this.form[ui.name] = form[ui.name]
          }
        })
      } else {
        this.form[field] = form[field]
      }
    },
    getPropValues() {
      const material_prop = this.othersUI.find(o => o.name === "material_prop_149422948")
      const UI = _.cloneDeep(this.propsUI);
      if(material_prop) {
        UI.push(material_prop)
      }
      const fieldDescriptorList = step3Form2Data(this.form, UI, this.oriDatas) || []
      return fieldDescriptorList.filter(item => item.defaultValue !== undefined || item?.children?.length);
    }
  }
}
</script>

<style lang="scss" scoped>
.category-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  padding-left: 10px;
}
.title {
  padding: 10px;
  background: #F8F8F8;
  font-weight: 600;
}
.props-items {
  padding: 20px 10px;

  & ::v-deep .el-form-item {
    display: inline-block;
    width: 50%;
    vertical-align: top;
  }
  & ::v-deep .el-select {
    width: 100%;
    .el-select__tags {
      max-width: none !important;
    }
  }
}
.useCategory-wrap {
 & ::v-deep .use-template-button {
    display: inline-block;
    height: 0;
    position: relative;
    bottom: 30px;
    left: 60px;
  }
}
.specifications-items, .logistics-items, .description-items, .others-items {
  padding: 20px 10px;
}
.noLabel {
  & ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
  & ::v-deep .el-form-item__error {
    margin-left: 12% !important;
  }
  & ::v-deep .extendsFields .el-form-item__error {
    position: static;
    margin-left: 0 !important;
  }
}

// 物流信息块
.logistics-items {
  .complex-items {
      display: flex;
      & ::v-deep .el-form-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          .el-form-item__label {
            width: 100% !important;
            text-align: left;
          }
          .el-form-item__content {
            margin: 0 !important;
            width: 95%;
          }
      }
  }
}

// 商品描述块
.description-items {
  .complex-items {
    & ::v-deep .complex-items {
      display: flex;
      flex-direction: column;
      .el-form-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-bottom: 15px;
          .el-form-item__label {
            width: 100% !important;
            text-align: left;
          }
          .el-form-item__content {
            margin: 0 !important;
            width: 95%;
          }
      }
    }
  }
  & ::v-deep .complex-items.item_attach_images {
    display: flex;
    .el-form-item {
      display: flex;
      flex-direction: column;
      margin-right: 10px;
      .el-form-item__label {
        width: 100% !important;
        text-align: left;
      }
      .el-form-item__content {
        margin: 0 !important;
        width: 95%;
      }
    }
  }
}

// 售后及其他
.others-items {
  & ::v-deep .el-form-item__content {
    width: 200px;
    .el-input-number, .el-select {
      width: 200px;
    }
    [class^=date-picker-erp] > div {
      width: 200px !important;
    }

    .multi-complex-items {
      width: 800px;
      .el-form-item__label {
        width: 120px !important;
      }
    }
  }
  & ::v-deep .complex-items.food_images {
    width: 900px;
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      margin-bottom: 10px!important;
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-form-item__label {
        width: 170px !important;
        text-align: left;
      }
      .el-form-item__content {
        margin: 0!important;
      }
    }

  }
  & ::v-deep .food_security_____food_nutrition_table, & ::v-deep .food_security_____product_date {
    .el-form-item {
      margin-bottom: 10px;
      .el-form-item__label {
        width: 600px!important;
        text-align: left;
        margin-left: 12%;
      }
    }

  }
}
.step3-form {
  & ::v-deep .el-input-number.is-without-controls {
    .el-input__inner {
      text-align: left;
    }
  } 
}
</style>